import NavSlot from "@/components/navigation/links";
import { Outlet } from "react-router-dom";
import TimesheetDepartmentEmployees from "./employees";
import TimesheetDepartmentOverview from "./overview";
import TimesheetDepartmentDashboard from "./dashboard";
import TimesheetDepartmentUtilization from "./utilization";

export const TimesheetDepartmentStatus = [
    {
        label: "Dashboard",
        value: "dashboard",
        path: "/reports/timesheet/department/dashboard",
        element: TimesheetDepartmentDashboard,
    },
    {
        label: "Utilization",
        value: "utilization",
        path: "/reports/timesheet/department/utilization",
        element: TimesheetDepartmentUtilization,
    },
    {
        label: "Overview",
        value: "overview",
        path: "/reports/timesheet/department/overview",
        element: TimesheetDepartmentOverview,
    },
    {
        label: "Employees",
        value: "employees",
        path: "/reports/timesheet/department/employees",
        element: TimesheetDepartmentEmployees,
    },
];

const TimesheetDepartmentLayout = () => {
    return (
        <div className="flex-1 overflow-auto relative ">
            <div className="sticky w-full bg-white z-1">
                <NavSlot navItems={TimesheetDepartmentStatus} />
            </div>
            <Outlet />
        </div>
    );
};

export default TimesheetDepartmentLayout;
